// Daily Mission translations
const dictMissions = {
    milestones: {
        th: "ไมล์สโตน",
        en: "Milestones",
        ja: "マイルストーン",
    },
    milestones_main_title: {
        th: "ไมล์สโตนทั้งหมด",
        en: "Milestones",
        ja: "マイルストーン",
    },
    milestones_progress: {
        th: "ความคืบหน้า",
        en: "Progress",
        ja: "達成状況",
    },
    daily_mission_main_title: {
        th: "ภารกิจประจำวัน",
        en: "Daily Missions",
        ja: "デイリーミッション",
    },
    not_started: {
        th: "ยังไม่เริ่ม",
        en: "Not Started",
        ja: "未完了",
    },
    in_progress: {
        th: "กำลังทำภารกิจ",
        en: "In Progress",
        ja: "進行中",
    },
    completed: {
        th: "สำเร็จแล้ว",
        en: "Completed",
        ja: "完了",
    },
    start_btn: {
        th: "เริ่มต้น",
        en: "Start",
        ja: "スタート",
    },
    continue_btn: {
        th: "ทำต่อ",
        en: "Continue",
        ja: "続ける",
    },
    pts: {
        th: "คะแนน",
        en: "pts",
        ja: "ポイント",
    },
    daily_points: {
        th: "คะแนนวันนี้",
        en: "Today's Points",
        ja: "今日のポイント",
    },
    daily_mission_progress: {
        th: "ความคืบหน้าภารกิจประจำวัน",
        en: "Daily mission progress",
        ja: "デイリーミッションの進捗",
    },
    open_daily_missions: {
        th: "เปิดภารกิจประจำวัน",
        en: "Open daily missions",
        ja: "デイリーミッションを開く",
    },
    view_history: {
        th: "ดูประวัติการได้คะแนนแบบสมบูรณ์",
        en: "View complete history",
        ja: "履歴を見る",
    },
    remaining_today: {
        th: "คะแนนที่เหลืออยู่ในวันนี้",
        en: "Remaining today",
        ja: "今日の残りポイント",
    },
    daily_missions_cleared: {
        th: "เคลียร์แล้ว",
        en: "Cleared",
        ja: "クリア済み",
    },
    daily_missions_footer_continue: {
        th: "เปิด Daily Missions เพื่อทำภารกิจต่อ",
        en: "Open Daily Missions to keep going",
        ja: "Daily Missions を開いて続きを進めましょう",
    },
    daily_missions_footer_complete: {
        th: "วันนี้ทำภารกิจครบแล้ว กลับมาใหม่พรุ่งนี้",
        en: "All daily missions are cleared. Come back tomorrow",
        ja: "今日のデイリーミッションは完了です。また明日戻ってきてください",
    },
    daily_mission_display_mode: {
        th: "การแสดง Daily Missions",
        en: "Daily Missions Display",
        ja: "デイリーミッションの表示モード",
    },
    daily_mission_mode_upper_stick: {
        th: "ตรึงด้านบน",
        en: "Upper",
        ja: "上部固定",
    },
    daily_mission_mode_upper_stick_short: {
        th: "Top",
        en: "Top",
        ja: "Top",
    },
    daily_mission_mode_floating: {
        th: "ลอยอิสระ",
        en: "Floating",
        ja: "フロート",
    },
    daily_mission_mode_floating_short: {
        th: "Float",
        en: "Float",
        ja: "Float",
    },
    daily_mission_mode_bottom_stick: {
        th: "ตรึงด้านล่าง",
        en: "Bottom",
        ja: "下部固定",
    },
    daily_mission_mode_bottom_stick_short: {
        th: "Bottom",
        en: "Bottom",
        ja: "Bottom",
    },
    daily_mission_mode_navbar: {
        th: "ใน Navbar",
        en: "Navbar",
        ja: "ナビバー",
    },
    daily_mission_mode_navbar_short: {
        th: "Nav",
        en: "Nav",
        ja: "Nav",
    },
    point_history_title: {
        th: "ประวัติคะแนน",
        en: "Point History",
        ja: "ポイント履歴",
    },
    point_history_show_invalid: {
        th: "แสดงรายการที่ถูกยกเลิก",
        en: "Show invalid only",
        ja: "無効データのみ表示",
    },
    point_history_add_points: {
        th: "เพิ่มคะแนน",
        en: "Add points",
        ja: "ポイント追加",
    },
    point_history_invalidate_points: {
        th: "ยกเลิกคะแนน",
        en: "Invalidate points",
        ja: "ポイント無効化",
    },
    point_history_amount: {
        th: "จำนวนคะแนน",
        en: "Amount",
        ja: "ポイント数",
    },
    point_history_rule: {
        th: "กฎ",
        en: "Rule",
        ja: "ルール",
    },
    point_history_note: {
        th: "หมายเหตุ",
        en: "Note",
        ja: "メモ",
    },
    point_rule_adjustment: {
        th: "ปรับคะแนนด้วยตนเอง",
        en: "Manual adjustment",
        ja: "手動ポイント付与",
    },
    point_rule_redeem: {
        th: "แลกคะแนน",
        en: "Point redeem",
        ja: "ポイント交換",
    },
    point_rule_first_registration: {
        th: "โบนัสสมัครครั้งแรก",
        en: "First registration bonus",
        ja: "初回登録ボーナス",
    },
    point_rule_profile_setup: {
        th: "ตั้งค่าโปรไฟล์ครั้งแรก",
        en: "Initial profile setup",
        ja: "初回プロフィール設定",
    },
    point_rule_profile_icon: {
        th: "ตั้งค่าไอคอนครั้งแรก",
        en: "Initial profile icon",
        ja: "初回アイコン設定",
    },
    point_rule_receive_like: {
        th: "ได้รับไลก์",
        en: "Receive likes",
        ja: "いいねをもらう",
    },
    point_rule_monthly_rank_1: {
        th: "อันดับ 1",
        en: "Rank #1",
        ja: "第1位",
    },
    point_rule_monthly_rank_2: {
        th: "อันดับ 2",
        en: "Rank #2",
        ja: "第2位",
    },
    point_rule_monthly_rank_3: {
        th: "อันดับ 3",
        en: "Rank #3",
        ja: "第3位",
    },
    point_rule_monthly_rank_4_5: {
        th: "อันดับ 4-5",
        en: "Rank #4-5",
        ja: "第4-5位",
    },
    point_rule_monthly_rank_6_10: {
        th: "อันดับ 6-10",
        en: "Rank #6-10",
        ja: "第6-10位",
    },
    point_rule_milestone_likes_50: {
        th: "ครบ 50 ไลก์",
        en: "Reach 50 likes",
        ja: "累計50いいね到達",
    },
    point_rule_milestone_likes_100: {
        th: "ครบ 100 ไลก์",
        en: "Reach 100 likes",
        ja: "累計100いいね到達",
    },
    point_rule_milestone_likes_300: {
        th: "ครบ 300 ไลก์",
        en: "Reach 300 likes",
        ja: "累計300いいね到達",
    },
    point_rule_milestone_likes_1000: {
        th: "ครบ 1,000 ไลก์",
        en: "Reach 1,000 likes",
        ja: "累計1,000いいね到達",
    },
    point_rule_milestone_likes_3000: {
        th: "ครบ 3,000 ไลก์",
        en: "Reach 3,000 likes",
        ja: "累計3,000いいね到達",
    },
    point_rule_milestone_reviews_50: {
        th: "ครบ 50 รีวิว",
        en: "Reach 50 reviews",
        ja: "累計50レビュー到達",
    },
    point_rule_milestone_reviews_100: {
        th: "ครบ 100 รีวิว",
        en: "Reach 100 reviews",
        ja: "累計100レビュー到達",
    },
    point_history_adjusted_success: {
        th: "อัปเดตคะแนนเรียบร้อยแล้ว",
        en: "Points updated successfully",
        ja: "ポイントを更新しました",
    },
    point_history_invalidated_success: {
        th: "ยกเลิกคะแนนเรียบร้อยแล้ว",
        en: "Point history invalidated successfully",
        ja: "ポイント履歴を無効化しました",
    },
    point_history_rule_required: {
        th: "จำเป็นต้องเลือกรูล",
        en: "Rule is required",
        ja: "ルールは必須です",
    },
    point_history_id_invalid: {
        th: "ID ประวัติคะแนนไม่ถูกต้อง",
        en: "Point history ID is invalid",
        ja: "ポイント履歴IDが不正です",
    },
    point_history_amount_non_zero_required: {
        th: "จำนวนคะแนนต้องเป็นตัวเลขและ 0 ไม่ได้",
        en: "Amount must be a non-zero number",
        ja: "金額は 0 以外の数値である必要があります",
    },
    point_history_update_failed: {
        th: "อัปเดตประวัติคะแนนไม่สำเร็จ",
        en: "Failed to update point history",
        ja: "ポイント履歴の更新に失敗しました",
    },
    invalidate: {
        th: "ยกเลิก",
        en: "Invalidate",
        ja: "無効化",
    },
    search_placeholder: {
        th: "ค้นหา...",
        en: "Search...",
        ja: "検索...",
    },
    date_from_placeholder: {
        th: "จากวันที่",
        en: "From Date",
        ja: "開始日",
    },
    date_to_placeholder: {
        th: "ถึงวันที่",
        en: "To Date",
        ja: "終了日",
    },
    loading: {
        th: "กำลังโหลด...",
        en: "Loading...",
        ja: "読込中...",
    },
};

export { dictMissions };
